// @flow

import React, { Component } from 'react';
import { IReduxState } from '../../../app/types';

import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n';
import { IconArrowUp } from '../../../base/icons';
import JitsiMeetJS from '../../../base/lib-jitsi-meet/_';
import { connect } from '../../../base/redux';
import { ToolboxButtonWithIcon } from '../../../base/toolbox/components';
import { AudioSettingsPopup, toggleAudioSettings } from '../../../settings';
import { getAudioSettingsVisibility } from '../../../settings/functions';
import { isAudioSettingsButtonDisabled } from '../../functions';
import AudioMuteButton from '../AudioMuteButton';
import { getLocalParticipant, PARTICIPANT_ROLE, getParticipantByIdOrUndefined } from '../../../base/participants';

type Props = {

    /**
     * The button's key.
     */
     buttonKey?: string,

    /**
     * External handler for click action.
     */
     handleClick: Function,

    /**
     * Indicates whether audio permissions have been granted or denied.
     */
    hasPermissions: boolean,

    /**
     * Click handler for the small icon. Opens audio options.
     */
    onAudioOptionsClick: Function,

    /**
     * If the button should be disabled.
     */
    isDisabled: boolean,

    /**
     * Notify mode for `toolbarButtonClicked` event -
     * whether to only notify or to also prevent button click routine.
     */
    notifyMode?: string,

    /**
     * Used for translation.
     */
    t: Function,

    /**
     * Flag controlling the visibility of the button.
     * AudioSettings popup is disabled on mobile browsers.
     */
    visible: boolean,

    /**
     * Defines is popup is open.
     */
    isOpen: boolean,

    settings: any,
    isShowPopup: boolean,
    tracks: Array,
    participant: Object,
};

/**
 * Button used for audio & audio settings.
 *
 * @returns {ReactElement}
 */
class AudioSettingsButton extends Component<Props> {
    /**
     * Initializes a new {@code AudioSettingsButton} instance.
     *
     * @inheritdoc
     */
    constructor(props: Props) {
        super(props);

        this._onEscClick = this._onEscClick.bind(this);
        this._onClick = this._onClick.bind(this);
    }

    _onEscClick: (KeyboardEvent) => void;

    /**
     * Click handler for the more actions entries.
     *
     * @param {KeyboardEvent} event - Esc key click to close the popup.
     * @returns {void}
     */
    _onEscClick(event) {
        if (event.key === 'Escape' && this.props.isOpen) {
            event.preventDefault();
            event.stopPropagation();
            this._onClick();
        }
    }

    _onClick: () => void;

    /**
     * Click handler for the more actions entries.
     *
     * @returns {void}
     */
    _onClick() {
        const { onAudioOptionsClick } = this.props;

        onAudioOptionsClick();
    }

    /**
     * Implements React's {@link Component#render}.
     *
     * @inheritdoc
     */
    render() {
        const { hasPermissions, isDisabled, visible, isOpen, buttonKey, notifyMode, t, settings, showCustom, customClass, tracks, participant, _localParticipant, onAudioOptionsClick  } = this.props;
        const track = tracks.find(tr => tr.participantId === participant?.id);
        let disabled = false;

/*         console.log("xxx participant in button: ", participant);
        console.log("xxx _localParticipant in button: ", _localParticipant);
        console.log("xxx _localParticipant.role in button: ", _localParticipant.role); 
        console.log("xxx PARTICIPANT_ROLE.MODERATOR in button: ", PARTICIPANT_ROLE.MODERATOR); 
        console.log("xxx _localParticipant.id in button: ", _localParticipant.id); 
        console.log("xxx participant?.id in button: ", participant?.id); 
        console.log("xxx track in button: ", track); 
        console.log("xxx tracks in button: ", tracks); 
        console.log("xxx participant?.enable in button: ", participant?.enable); 
        console.log("xxx track?.muted in button: ", track?.muted);
        console.log("xxx hasPermissions in button: ", hasPermissions); 
        console.log("xxx isDisabled in button: ", isDisabled); 
        console.log("xxx visible in button: ", visible); 
        console.log("xxx settings in button: ", settings); 
        console.log("xxx showCustom in button: ", showCustom); 
        console.log("xxx customClass in button: ", customClass);  */

        if (!track) {
            disabled = true;
        }
/*         if (_localParticipant.role === PARTICIPANT_ROLE.MODERATOR && _localParticipant.id !== participant?.id) {
            participant?.enable ? disabled = true : disabled = false;
        }
        if (_localParticipant.role !== PARTICIPANT_ROLE.MODERATOR && _localParticipant.id !== participant?.id) {
            disabled = true;
        }

        if (_localParticipant.id === participant?.id && (!participant?.enable || participant?.enable !== 'undefined') && track?.muted) {
            disabled = true;
        } */
        const settingsDisabled = !hasPermissions
            || isDisabled
            || !JitsiMeetJS.mediaDevices.isMultipleAudioInputSupported();
        
        // console.log("xxx disabled in button: ", disabled);

        return visible
            ? this.props.isShowPopup
                ? (settings.mode === 'participant' || !settings.user === true) && <AudioSettingsPopup>
                    <ToolboxButtonWithIcon
                        icon={IconArrowUp}
                        iconDisabled={settingsDisabled}
                        iconTooltip={t('toolbar.audioSettings')}
                        onIconClick={onAudioOptionsClick}>
                        <AudioMuteButton
                            // customClass={customClass ? customClass : 'hide-button-900 hide-icon-900'}
                            showCustom={showCustom} />
                    </ToolboxButtonWithIcon>
                </AudioSettingsPopup> : 
                <AudioMuteButton
                    disabled={disabled}
                    customClass= { customClass ? customClass : `hide-button-900 hide-icon-900 ${disabled && 'audio-disable'}`}
                    showCustom={showCustom} />
            : <AudioMuteButton
                disabled={disabled}
                customClass={`${disabled ? 'audio-disable' : 'background-theme-2'}  hide-button-900 hide-icon-900`}
                showCustom={showCustom} />;
    }
}

/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    const { permissions = {} } = state['features/base/devices'];
    const { isNarrowLayout } = state['features/base/responsive-ui'];
    const settings = state['features/base/settings'];
    //const localParticipant = Object.keys(state['features/base/participants']).filter(p => p.local);
    const localParticipant = getLocalParticipant(state);
    const participants = state['features/base/participants'];
    const tracks = state['features/base/tracks'];

    return {
        hasPermissions: permissions.audio,
        _localParticipant: localParticipant,
        // participant: Object.keys(participants).find(p => p.id === localParticipant.id),
        participant: getParticipantByIdOrUndefined(state, localParticipant.id),

        // participant: participants.filter(p => p.id === localParticipant.id),
        // participant: getLocalParticipant(state),
        tracks,
        isDisabled: isAudioSettingsButtonDisabled(state),
        isOpen: getAudioSettingsVisibility(state),
        visible: !isMobileBrowser() && !isNarrowLayout,
        settings
    };
}

const mapDispatchToProps = {
    onAudioOptionsClick: toggleAudioSettings
};

export default translate(connect(
    mapStateToProps,
    mapDispatchToProps
)(AudioSettingsButton));
